<style lang="less" scoped>


.user_footer {
    position: inherit;
    bottom: 0;
    width: 100%;
}

.layout {
    display: flex;

    .left {
        width: 165px;
    }

    .right {
        margin-left: 20px;
        width: 970px;
    }
}
</style>

<template>
    <div class="bg-white frame">
        <div class="frame-content h-60-px tb-row-scatter tb_align-center">
            <div class="tb-row">
                <h1>{{ baseJson.title }}</h1>
            </div>
            <div class="tb-row tb_align-center">
                <!--        <div class="p-r-20 c-h" @click="">公章备案</div>-->
                <!--        <div class="p-r-20 c-h" @click="">电子签章</div>-->
                <!--        <div class="p-r-20 c-h" @click="">帮助文档</div>-->
                <div class="p-r-20 tb-row tb_align-center c-h" @click="goUrl({url:'custom/center'})">
                    <!--<Avatar icon="md-person" :src="user.extPhotoHeadOss|img_oss('tubo_11_tiny')" size="large"/>-->
                    <Icon type="md-person"></Icon>
                    <div class="p-l-5">{{ user.extNickName || '新用户' }}</div>
                </div>
                <div class="c-h" @click="loginOut">注销</div>
            </div>
        </div>
        <div class="frame-content tb_align-center m-t-15 m-b-25" style="padding-bottom:58px">
            <div class="tb-column-center m-b-15">
                <img :src="pageConfig.adImg" class="m-b-10">
            </div>
            <div class="user_center">
                <div class="layout">
                    <div class="left">
                        <Menu theme="light" width="auto" :open-names="breadcrumb.category"
                              :active-name="breadcrumb.page">
                            <Menu-item :name="item.url" :class="{'ivu-menu-item-active':menuActive == index}"
                                       v-for="(item, index) in centerPages.menu" :key="item.url"
                                       @click.native="menuActive = index,goUrl(item)">{{ item.title }}
                            </Menu-item>
                        </Menu>
                    </div>
                    <div class="right">
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-c c-gray p-20 user_footer bg-white">
            <!--      {{baseJson.title}} {{baseJson.origin}}-->
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    data() {
        return {
            active: this.$route.path,
            menuActive: null
        }
    },
    computed: {
        ...mapState({
            user: state => state.custom.user,
            breadcrumb: state => state.main.breadcrumb,
            centerPages: state => state.custom.centerPages,
            baseJson: state => state.main.config.baseJson,
            pageConfig: state => state.main.config
        })
    },
    methods: {
        loginOut() {
            this.$store.commit('custom/SET_USER_LOGOUT')
            this.$router.push({path: '/frame/login', query: {redirect: this.$route.fullPath}})
        },
        goUrl(item) {
            this.$router.push({path: '/' + item.url, query: item.query})
        }
    },
    created() {
        this.centerPages.menu.forEach((item, index) => {
            if (window.location.href.indexOf(item.url) > -1) this.menuActive = index
        })
    }
}
</script>
